type SpinnerProps = {
  size?: number;
  color?: string;
};

const Spinner: React.FC<SpinnerProps> = ({
  size = 56,
  color = "",
}) => {
  return (
    <div
      style={{
      width: size,
      height: size,
      borderRadius: "50%",
      background: `conic-gradient(#0000 10%, ${color || "var(--color-primary)"})`,
      WebkitMask:
        "radial-gradient(farthest-side, #0000 calc(100% - 9px), #000 0)",
      animation: "spin 1s linear infinite",
      }}
    >
      <style>
      {`
      @keyframes spin {
        to {
        transform: rotate(1turn);
        }
      }
      `}
      </style>
    </div>
  );
};

export default Spinner;
